export const copyTextToClipboard = (text: string) => {
    // create dummy textarea
    var dummy = document.createElement("textarea");
    // append it to body
    document.body.appendChild(dummy);
    // set value of dummy element
    dummy.value = text;
    // highlight textarea
    dummy.select();
    // copy
    document.execCommand("copy");
    // remove dummy textarea
    document.body.removeChild(dummy);
}